/**
 * Bundle 141 - Analytics landing page.
 * Route: /admin/analytics (the previous data dashboard moved to
 * /admin/analytics/overview).
 */
import React from 'react';
import AdminSectionLandingPage from './AdminSectionLandingPage';

const AdminAnalyticsLandingPage = () => (
  <AdminSectionLandingPage
    section="analytics"
    testidPrefix="admin-analytics-landing"
  />
);

export default AdminAnalyticsLandingPage;
